// client/src/routes/app/onboarding.tsx — SCR-ONB-001 · UI-006 (04 §8.1, §9.2).
//
// NO `RequirePermission`. 04 §8.1 gives this screen no permission column and 05 UI-006 no role,
// and the wizard is reached by exactly two paths — the register flow, whose user is the new
// organization's owner, and (from FIN-005) a link on the Dashboard's empty state. Gating the
// route on `Portfolio.Write` would render SCR-SYS-403 to a manager who holds it, because the
// mirror would have to name one code while the flow spends three; and it would tell an
// accountant „nu ai acces" when the honest answer is that the API refuses the first CREATE with
// a rule the form already renders. The client mirror is UX only either way (§9.2.2) — the
// enforcement is the API's, on each of the three writes. See DEVIATIONS D-744.

import { createFileRoute } from '@tanstack/react-router';

import { OnboardingWizard } from '@/features/onboarding/OnboardingWizard';

export const Route = createFileRoute('/app/onboarding')({
  component: OnboardingScreen,
});

function OnboardingScreen() {
  return <OnboardingWizard />;
}
